import { render, staticRenderFns } from "./ReporteSerieBase.vue?vue&type=template&id=8d352a50&"
import script from "./ReporteSerieBase.vue?vue&type=script&lang=ts&"
export * from "./ReporteSerieBase.vue?vue&type=script&lang=ts&"
import style0 from "./ReporteSerieBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports